import { render, staticRenderFns } from "./ColorPickerPlaceholder.vue?vue&type=template&id=2f0eeaa9"
import script from "./ColorPickerPlaceholder.vue?vue&type=script&lang=js"
export * from "./ColorPickerPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerPlaceholder.vue?vue&type=style&index=0&id=2f0eeaa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports